{
  "en": {
    "Base.ErrorHeader": "Error",
    "Base.ErrorInfo.ErrorDescription.Generic": "An unexpected error occurred",
    "errorPanel.label.timestamp": "Timestamp",
    "errorPanel.label.sessionId": "Session ID",
    "errorPanel.label.error": "Error",
    "errorPanel.label.serverCode": "Server Code",
    "Base.ErrorPanel.Button.CopyToClipboard": "Copy to Clipboard",
    "Base.ErrorPanel.Button.Undo": "Undo",
    "Base.AppTitle": "App Suite",
    "test.dynamic.msg": "Hello {0}, you are logged in as {1}",
    "test.role.admin": "Administrator"
  }
}
